import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';

export const FinanceDashboardNetChart = ({
  startPeriod,
  endPeriod,
  periodicity,
  prodIds,
  channelIds,
  chartType,
  entity,
  periods
}) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  // const periodIds = periods;


  useEffect(() => {
    if (!prodIds?.length) return;
    if (!channelIds?.length) return;

    const ndc11ProdIds = prodIds.map((prod) => prod);
    const reqParam = { chartType, startPeriod, endPeriod, periodicity, ndc11ProdIds, channelIds, entity };

    rsrc
      .data('gtn', 'PL_NET_DASHBOARD_DATA_PLUGIN', reqParam, entity)
      .then((rows) => setData(rows));
  }, [chartType, startPeriod, endPeriod, periodicity, prodIds, channelIds, entity]);

  if (!data) return null;


  // const colorMap = {
  //   Net: '#4caf50',
  //   Commercial: '#ffcdd2',          // very light red
  //   'Managed Care (YD)': '#ef9a9a', // light red
  //   ADAP: '#ffb74d',                // soft orange
  //   Medicaid: '#ff9800',            // medium orange
  //   FSS: '#f57c00',                 // deeper orWITH
  //   PHS: '#e53935',                 // strong red-orange
  //   'US Gross Sales': '#2196f3' // thin reference bar
  // };

  // const filteredData = {
  //   ...data,
  //   series: data.series
  //     .filter(s => s.label === 'Net Sales')
  //     .map(s => {
  //       const baseline = s.values[0]; // first quarter value
  //       const rebasedValues = s.values.map(v => v - baseline); // difference from baseline
  //       return { ...s, type: 'line', values: rebasedValues };
  //     }),
  // };

const filteredData = (() => {
  if (!data || !data.series) return data;

  // Use top-level categories as periods if series doesn't have its own
  const globalPeriods = data.categories || data.periods || [];

  // 12 for months, 4 for quarters
  const lag = periodicity === 'Monthly' ? 12 : 4;

  const filteredSeries = data.series
    .filter(s => s.label === 'Net Sales')
    .map(s => {
      const { values } = s;
      if (!Array.isArray(values)) return s;

      // compute year-over-year % change
      const rebasedValues = values.map((v, i) => {
        if (i < lag) return null; // no year-ago period
        const baseline = values[i - lag];
        if (baseline == null || baseline === 0) return null;
        return ((v - baseline) / baseline) * 100; // convert to %
      });

      // trim from startPeriod onward
      const startIdx = globalPeriods.indexOf(startPeriod);
      const slicedPeriods = startIdx >= 0 ? globalPeriods.slice(startIdx) : [];
      const slicedValues =
        startIdx >= 0
          ? rebasedValues.slice(startIdx).map(v => (v != null ? Number(v.toFixed(1)) : null))
          : rebasedValues.map(v => (v != null ? Number(v.toFixed(1)) : null));

      return {
        ...s,
        type: 'line',
        label: `${s.label} YoY % Change`,
        periods: slicedPeriods,
        values: slicedValues,
      };
    });

  // update top-level categories too
  const startIdx = globalPeriods.indexOf(startPeriod);
  const newCategories = startIdx >= 0 ? globalPeriods.slice(startIdx) : globalPeriods;

  return {
    ...data,
    categories: newCategories,
    series: filteredSeries,
  };
})();






  return (
    <CartesianChart
      data={filteredData}
      markers
      allowNegative={true}
      isZones={true}
      stacked={true}

    />
  );
};
